export enum CookieType {
  AccessToken = "AccessToken",
  CodePressId = "CodePressId",
  ProductIdList = "ProductIdList",
  RedirectLocation = "RedirectLocation"
}
